export const reactSelectStyles = { 
    menu: (provided) => ({ 
      ...provided, 
        zIndex: 3,
        borderRadius: '0px',
    }),
    control: (provided, state) => ({
        ...provided,
        '&:hover': {
          borderColor:'none'
        },
        border: state.isFocused  ? '2px solid #F47B33!important;' : '0px',
        backgroundColor: '#ECF0F2',
        borderBottom: state.isDisabled ? '2px solid rgba(255, 0, 0, 0)' : '2px solid #838D91',
        boxShadow: 'none',
        borderColor: '#838D91',
        borderTop: '2px solid rgba(255, 0, 0, 0)',
        borderLeft: '2px solid rgba(255, 0, 0, 0)',
        borderRight: '2px solid rgba(255, 0, 0, 0)',
        borderRadius: '0',
      }),
    singleValue: (provided, state) => ({
      ...provided,
      color: state.isDisabled ? '#B9C2C7' : '#0B0E10'
    })

}